import React from 'react';

export const FlagFilled = ({
  className,
  color,
  height,
  width
}: {
  className?: string;
  height?:number;
  width?:number;
  color?: string;
}) => (
  <svg
    width={width ?? 20}
    height={height ?? 21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="20"
      height="20"
      transform="translate(0 0.881836)"
      fill="white"
      fillOpacity="0.01"
    />
    <path
      d="M5 11.0775V16.4492C5 16.8967 5.375 17.2633 5.83333 17.2633C6.29167 17.2633 6.66667 16.8967 6.66667 16.4492V11.6342C7.64167 11.35 8.6575 11.5967 9.80667 11.8758C10.625 12.0742 11.5033 12.2883 12.415 12.2883C13.1494 12.2962 13.8758 12.1345 14.5375 11.8158C14.6782 11.7475 14.7969 11.6409 14.8798 11.5082C14.9628 11.3756 15.0067 11.2223 15.0067 11.0658V5.43665C15.0072 5.2952 14.9716 5.15596 14.9034 5.03208C14.8351 4.9082 14.7363 4.80378 14.6164 4.7287C14.4966 4.65362 14.3595 4.61035 14.2183 4.60299C14.077 4.59564 13.9362 4.62443 13.8092 4.68665C12.6883 5.23165 11.5333 4.95082 10.2 4.62749C8.75917 4.27749 7.1275 3.88165 5.46833 4.68749C5.3279 4.75591 5.20952 4.86243 5.12671 4.9949C5.0439 5.12736 5 5.28044 5 5.43665V11.0775Z"
      fill={color || '#FF5630'}
    />
  </svg>
);
